import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetProviderBio from './ProviderBio.graphql';

export const useProviderBio = (options) =>
  useCustomQuery(GetProviderBio, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'providerBio',
  });
